var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ignore"},[_c('img',{staticClass:"ercode",class:_vm.size,attrs:{"src":_vm.imageTypeEnum[_vm.imageType],"alt":"loklok placeholder","width":"200","height":"200"}}),_c('h1',[_vm._v(_vm._s(_vm.title || _vm.$t('globalTip.emptyTip')))]),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }